function highlightRichText(text: string): string {
  return text
    .replace(/<highlight>/g,
             "<span class='clip-detail__highlight'>")
    .replace(/<\/highlight>/g, "</span>");
}

export default highlightRichText
